import { defineStore } from 'pinia';

interface PageState {
  routeData: any;
}

export const usePageStore = defineStore('page', {
  state: (): PageState => ({
    routeData: null,
  }),
  getters: {
    getPageType(state) {
      return state.routeData?.type ?? '';
    },
    getPageLevel(state) {
      return state.routeData?.level ?? '';
    },
  },
});
